<ion-content>
  <ion-toolbar class="pad10">
    <ion-title class="font18 font600 title-text-color">{{
      "membership.voucher.add_voucher" | translate
    }}</ion-title>
    <ion-button fill="clear" color="dark" (click)="closeModal()" slot="end">
      <ion-icon
        slot="icon-only"
        name="close"
        class="primary-icon-color"
      ></ion-icon>
    </ion-button>
  </ion-toolbar>
  <div class="ion-no-padding ion-padding-horizontal ion-margin-horizontal">
    <form
      novalidate
      class="formCls mart10"
      *ngIf="!submittedSuccess; else submitSuccess"
    >
      <ion-input
        type="text"
        [(ngModel)]="voucherCode"
        name="voucherCode"
        placeholder="Please enter your voucher code"
        aria-label="voucherCode"
        class="ion-padding voucher_code font14 font600"
      >
      </ion-input>
      <div class="show-error ion-text-center ion-margin-bottom">
        <div>
          {{ error }}
        </div>
      </div>
      <ion-button
        [disabled]="!voucherCode"
        (click)="submitRequest()"
        mode="ios"
        expand="block"
        class="mart10"
        fill="solid"
      >
        {{ "membership.voucher.Verify" | translate }}
      </ion-button>
    </form>

    <ng-template #submitSuccess>
      <div>
        <ion-grid class="ion-no-padding" style="height: 100%">
          <ion-row
            class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
            style="height: 100%; flex-direction: column"
          >
            <div style="width: 95%">
              <ion-card class="ion-margin-bottom no-shadow ion-text-center">
                <img
                  [src]="'assets/images/success-icon.png'"
                  style="margin: auto"
                />
                <ion-card-title class="font16 ion-padding-top">
                  {{
                    "membership.voucher.you_have_added_premium_membership_successfully"
                      | translate
                  }}
                </ion-card-title>
              </ion-card>
            </div>
          </ion-row>
        </ion-grid>
      </div>
    </ng-template>
  </div>
</ion-content>
